export const outlineBtnClass =
  'h-10 gap-2 rounded-xl border border-[#e7e9ef] bg-white px-3 py-3 text-base font-medium leading-none text-[#171a20] hover:bg-[#f4f5f8]'

export const primaryBtnClass =
  'h-10 gap-2 rounded-xl border border-[#ff5a1f] bg-[#ff5a1f] px-3 py-3 text-base font-medium leading-none text-white hover:bg-[#e6511c]'

export const restyleFieldClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none shadow-none placeholder:font-normal focus-visible:ring-0 focus-visible:ring-offset-0'

export const restylePickerClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none shadow-none hover:bg-[#eceef2] focus-visible:ring-0 focus-visible:ring-offset-0 [&>span]:font-normal data-[has-value=true]:[&>span]:font-medium [&>span>span]:font-normal data-[has-value=true]:[&>span>span]:font-medium'

export const restyleDateClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none shadow-none [&_input]:font-medium'

export const restyleDisabledClass =
  'h-10 rounded-xl border-0 bg-[#e7e9ef] px-4 py-3 text-base font-medium leading-none text-[#6c7285] disabled:cursor-default disabled:opacity-100'

export const restyleSelectClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none shadow-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:ring-0 data-[placeholder]:font-normal [&>span]:font-medium data-[placeholder]:[&>span]:font-normal [&>span>span]:font-medium data-[placeholder]:[&>span>span]:font-normal'

export const amountInclClass =
  'h-10 rounded-xl border border-[#ff9d75] bg-[#fff1ea] px-4 py-3 text-base font-medium leading-none text-[#ff5a1f] disabled:cursor-default disabled:opacity-100'

export const chipShadow = 'shadow-[0_1px_4px_0_rgba(38,45,66,0.05)]'

export const newCustomerBtnClass =
  'h-10 shrink-0 gap-2 rounded-xl border border-dashed border-[#ff5a1f] bg-white px-3 py-3 text-base font-medium leading-none text-[#ff5a1f] hover:bg-[#fff1ea]'

export const restyleFilledClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none text-[#171a20] shadow-none placeholder:font-normal focus-visible:ring-0 focus-visible:ring-offset-0'

export const restyleSelectFilledClass =
  'h-10 rounded-xl border-0 bg-[#f4f5f8] px-4 py-3 text-base font-medium leading-none shadow-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:ring-0 [&>span]:line-clamp-none [&>span]:whitespace-nowrap [&>span]:font-medium [&>span>span]:font-medium'

export const dashedAddBtnClass =
  'h-10 w-fit shrink-0 gap-2 rounded-xl border border-dashed border-[#b0b5c3] bg-white px-3 py-3 text-base font-medium leading-none text-[#171a20] hover:bg-[#f4f5f8]'

export const restyleDeleteBtnClass =
  'size-10 shrink-0 rounded-xl border border-[#e7e9ef] bg-white p-2.5 text-[#171a20] hover:bg-[#f4f5f8]'

export const restyleLabelClass =
  'flex h-4 w-full shrink-0 items-center gap-1 overflow-hidden whitespace-nowrap text-xs font-semibold leading-4 text-[#171a20]'
